import React from 'react';
import styled from 'styled-components';
import { IconSmallCheckLegacy } from '@prezi/common-design';

import { DropdownItem } from '../Dropdown/DropdownItem';

export type DropdownSelectOptionProps<T> = {
    value?: T;
    disabled?: boolean;
    selectedValue?: T;
    icon?: JSX.Element;
    children?: React.ReactNode;
    onChange?: (newValue: T) => void;
};

const OptionLabel = styled.div`
    color: ${({ theme }) => theme.bento.colors.text.main};
    &[aria-disabled='true'] {
        color: ${({ theme }) => theme.bento.colors.text.weak};
        cursor: not-allowed;
    }
`;

export const SelectIconPlaceholder = styled.div`
    width: 24px;
    height: 24px;
`;

export function DropdownSelectOption<T>({
    value,
    icon,
    disabled = false,
    selectedValue,
    children,
    onChange,
}: DropdownSelectOptionProps<T>) {
    const selectedIcon = icon || <IconSmallCheckLegacy />;

    return (
        <DropdownItem
            isActive={selectedValue === value}
            iconLeft={selectedValue === value ? selectedIcon : <SelectIconPlaceholder />}
            onClick={() => value && !disabled && onChange && onChange(value)}
        >
            <OptionLabel aria-disabled={disabled}>{children}</OptionLabel>
        </DropdownItem>
    );
}
